"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const createBlockingWriter = (stream) => {
    return {
        write: (message) => {
            stream.write(message + '\n');
        },
    };
};
exports.default = () => {
    var _a;
    // eslint-disable-next-line node/no-process-env
    const targetStream = ((_a = process.env.ROARR_STREAM) !== null && _a !== void 0 ? _a : 'STDOUT').toUpperCase();
    const stream = targetStream.toUpperCase() === 'STDOUT' ? process.stdout : process.stderr;
    return createBlockingWriter(stream);
};
